import React from "react";
import { NumberInput } from "react-admin";
import { BooleanInput } from "react-admin";
import PlayerStats from "./PlayerStats";

const BaseballPlayerStats = ({ s }) => {
  return (
    <PlayerStats s={s}>
      <NumberInput label="Home Runs" source={s("homeRuns")} />
      <NumberInput label="Doubles" source={s("doubles")} />
      <NumberInput label="Triples" source={s("triples")} />
      <BooleanInput label="Pitcher" source={s("isPitcher")} />
    </PlayerStats>
  );
};

export default BaseballPlayerStats;
